// extracted by mini-css-extract-plugin
export default {"loading":"Loader_loading__Rb1OM","spin":"Loader_spin__E4RJ0","loadsuccess":"Loader_loadsuccess__W9JGR","loaderror":"Loader_loaderror__yox0U","mini":"Loader_mini__GVVED"};